import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgStackLarge = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={100}
      height={100}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M36.503 29.141H29.14v7.362h-7.362v7.362h-7.362v34.356h49.08v-7.362h7.362v-7.362h7.362v-7.362h7.362V21.779h-49.08v7.362Zm24.54 46.626H16.87V46.319h44.172v29.448Zm7.362-7.362h-4.908v-24.54H24.233v-4.908h44.172v29.448Zm7.362-7.362h-4.908v-24.54H31.595v-4.908h44.172v29.448Zm-36.81-36.81h44.172v29.448H78.22v-24.54H38.957v-4.908Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgStackLarge;
